import hackernews from "./hackernews";

export default {
  ...hackernews,
};
